<template>
  <v-navigation-drawer
    v-model="navState.drawer"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
  >
    <v-list dense>
      <template v-for="item in displayableItems">
        <v-row v-if="item.heading" :key="item.heading" align="center">
          <v-col cols="6">
            <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
          </v-col>
          <v-col cols="6" class="text-center">
            <a href="#!" class="body-2 black--text">EDIT</a>
          </v-col>
        </v-row>
        <v-list-group
          class="mt-4" 
          v-else-if="item.children"
          :key="item.text"
          v-model="item.active"
        >
          <template v-slot:activator>
            <v-list-item :to="item.link" link>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-list-item v-for="(child, i) in item.children" :key="i" :to="child.link" link>
            <v-list-item-action v-if="child.icon">
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ child.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item v-else :key="item.text" :to="item.link" link>
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Role } from "@/router/_helper";

export default {
  data: () => ({
    items: [
      {
        icon: "mdi-home",
        text: "Home",
        link: "/",
      },
      {
        icon: "mdi-account-tie-voice-outline",
        text: "Staff",
        link: "/staff",
      },
      {
        icon: "mdi-folder-move-outline",
        text: "Staff Submissions",
        link: "/staffRequirementSubmission",
      },
      {
        icon: "mdi-chart-box-outline",
        text: "Staff Summary",
        link: "/staff-summary",
      },
      {
        icon: "mdi-human-child",
        text: "Students",
        link: "/student",
      },
      {
        icon: "mdi-folder-move-outline",
        text: "Student Submissions",
        link: "/studentRequirementSubmission",
      },
      {
        icon: "mdi-chart-box-outline",
        text: "Student Summary",
        link: "/student-summary",
      },
      // { heading: 'Settings' },
      {
        icon: "mdi-cog-outline",
        text: "Settings",
        meta: { authorize: [Role.Admin, Role.ComplianceAdmin], requiresAuth: true },
        children: [
          {
            icon: "mdi-alpha-r-box-outline",
            text: "Requirements",
            link: "/requirement",
          },
          {
            icon: "mdi-medication-outline",
            text: "Medical Alert",
            link: "/medicalAlert",
          },
          {
            icon: "mdi-google-classroom",
            text: "Classrooms",
            link: "/classroom",
          },
          {
            icon: "mdi-numeric",
            text: "Grade",
            link: "/grade",
          },
        ],
      },
    ],
  }),

  computed: {
    ...mapGetters("auth", ["isLoggedIn", "currentUser", "userRoles"]),
    ...mapGetters("navigation", ["navState"]),
    displayableItems() {
      const allRoutes = this.$router.options.routes;
      const filterList = (items) => {
        return items.filter((item) => {
          let authorize = null;
          const route = allRoutes.find((r) => r.path == item.link || (item.to && r.name == item.to.name));
          if (route && route.meta ) {
            authorize = route.meta.authorize;
            return this.isLoggedIn && this.isAuthorized(authorize);
          } 
          else if(item.children){
            authorize = item.meta ? item.meta.authorize:[];
            return this.isLoggedIn && this.isAuthorized(authorize);
          }
          else if (!route) {
            console.warn("Uknown route found in Sidebar: " + item.link);
            return false;
          } else {
            return true; //include menu withtout authorize filter
          }
        });
      }

      const topLevels = filterList(this.items);
      if(topLevels){
        topLevels.forEach(top => {
          if(top && top.children && top.children.length > 0){
            top.children = filterList(top.children);
          }
        })
      }

      return topLevels;
    },
  },
  methods: {
    ...mapActions("messages", ["addErrorMessage"]),
    isAuthorized(roles) {
      if (!roles || roles.length < 1) {
        return true;
      }
      if (this.userRoles && this.userRoles.length > 0) {
        return this.userRoles.some((r) => roles.includes(r));
      } else {
        this.addErrorMessage("Unauthorized Access");
        return false;
      }
    },
  },
};
</script>

<style>
</style>